// extracted by mini-css-extract-plugin
export var localeSelector = "_bv-0";